import {fetch, post, put, remove} from '@/base-http';
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'

/**
 * Obtiene la lista de galerías registradas en la aplicación
 */
export async function getGalleryList () {
    const data = await fetch('/cms/galleries')
    if (!Array.isArray(data)) {
        throw new Error(`Se esperaba un array con las galerías, se obtuvo ${typeof data}`)
    }

    return data.map(g => Gallery.deserialize(g))
}

/**
 * Obtiene una galería desde la api
 * @param id
 */
export async function getGallery (id: number) {
    const data = await fetch(`/cms/gallery/${id}`)

    return Gallery.deserialize(data)
}

/**
 * Actualiza una galería
 *
 * @param gallery
 */
export async function updateGallery (gallery: Gallery) {
    if (gallery.isNew) {
        throw new Error('No se puede actualizar una galería que todavía no ha sido registrada')
    }

    const updated = await put(`/cms/gallery/${gallery.id}`, gallery.serialize())

    return Gallery.deserialize(updated)
}

/**
 * Crea una nueva galería en el servidor
 *
 * @param gallery
 */
export async function createGallery (gallery: Gallery) {
    if (!gallery.isNew) {
        throw new Error('No se puede crear una galería que ya ha sido registrada')
    }

    const created = await post(`/cms/gallery`, gallery.serialize())

    return Gallery.deserialize(created)
}


/**
 * Elimina una galería
 *
 * @param gallery
 */
export async function deleteGallery (gallery: Gallery) {
    if (gallery.isNew) {
        throw new Error('No se puede eliminar un galería que no se ha registrado')
    }

    const result = await remove(`/cms/gallery/${gallery.id}`)

    return result.message === 'success'
}
